import React, { useRef } from "react";

const YouTubePlayer = ({ videoId, width, height }) => {
  const iframeRef = useRef(null);

  return (
    <div>
      <iframe
        ref={iframeRef}
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture fullscreen"
        allowFullScreen
        data-playing="false"
        title="YouTube Video"
      ></iframe>
    </div>
  );
};

export default YouTubePlayer;
